export const WHATSAPP_CONTACT_BOT_NUMBER = "97233825202";
export const WHATSAPP_CONTACT_COMPLETION_PHRASE = "סיימתי";

const hasPositiveBalance = (value) => (parseInt(String(value || "0"), 10) || 0) > 0;

export const hasLegacyMessagingEntitlement = ({
  messageBankPurchased = false,
  messageGiftClaimed = false,
  hasMessageHistory = false,
  smsBank = 0,
  whatsAppBank = 0,
} = {}) => (
  messageBankPurchased === true ||
  messageGiftClaimed === true ||
  hasMessageHistory === true ||
  hasPositiveBalance(smsBank) ||
  hasPositiveBalance(whatsAppBank)
);

export const shouldOfferAutopilotPurchase = ({
  packageRecordEntitled = false,
  isReadOnly = false,
  rsvpAccess = null,
  smsBank = 0,
  whatsAppBank = 0,
} = {}) => (
  isReadOnly !== true &&
  packageRecordEntitled !== true &&
  hasPositiveBalance(smsBank) !== true &&
  hasPositiveBalance(whatsAppBank) !== true &&
  (rsvpAccess == null || ["FREE", "MANUAL"].includes(String(rsvpAccess.classification || "")))
);

export const canUseWhatsAppContactImport = () => true;

export const buildWhatsAppContactBotMessage = ({ docID, email }) => [
  "שלום, אנחנו רוצים להעלות אנשי קשר למערכת.",
  "",
  `מספר לקוח: ${String(docID || "").trim()}`,
  `אימייל בעל האירוע: ${String(email || "").trim()}`,
  "",
  `כעת נשלח את אנשי הקשר. לאחר שנסיים נכתוב: "${WHATSAPP_CONTACT_COMPLETION_PHRASE}".`,
].join("\n");

export const buildWhatsAppContactBotUrl = ({ docID, email }) => {
  const message = buildWhatsAppContactBotMessage({ docID, email });
  return `https://wa.me/${WHATSAPP_CONTACT_BOT_NUMBER}?text=${encodeURIComponent(message)}`;
};
